import React from 'react';
export function Ticker() {
  const items = [{
    text: 'Diseño Web Profesional',
    variant: 'neon'
  }, {
    text: 'SEO Optimizado',
    variant: 'blue'
  }, {
    text: 'Captura de Leads 24/7',
    variant: 'default'
  }, {
    text: 'Responsive Mobile',
    variant: 'neon'
  }, {
    text: 'Carga Ultrarrápida',
    variant: 'default'
  }, {
    text: 'Entrega en 7 Días',
    variant: 'blue'
  }, {
    text: 'Soporte Continuo',
    variant: 'neon'
  }, {
    text: 'Analytics Incluido',
    variant: 'default'
  }];
  return <div className="overflow-hidden border-t border-b border-[var(--border)] bg-[var(--bg-2)] py-4" aria-label="Características disponibles" aria-hidden="true" data-id="element-265">
      <div className="ticker-track flex w-max" data-id="element-266">
        {[...items, ...items].map((item, i) => <div key={i} className={`flex items-center gap-3 px-9 whitespace-nowrap text-[13px] font-bold tracking-[0.06em] uppercase ${item.variant === 'neon' ? 'text-[var(--neon)]' : item.variant === 'blue' ? 'text-[var(--blue)]' : 'text-[var(--text-muted)]'}`} data-id="element-267">
            <span className={`w-[5px] h-[5px] rounded-full flex-shrink-0 ${item.variant === 'neon' ? 'bg-[var(--neon)] shadow-[0_0_8px_var(--neon)]' : item.variant === 'blue' ? 'bg-[var(--blue)] shadow-[0_0_8px_var(--blue)]' : 'bg-[var(--text-subtle)]'}`} data-id="element-268"></span>
            {item.text}
          </div>)}
      </div>
    </div>;
}